var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value === 'gph')?_c('span',{staticClass:"employee-hiring-badge",attrs:{"title":_vm.showTooltip ? 'Форма найма: ГПХ' : null,"aria-label":"Форма найма: ГПХ"}},[_vm._v("ГПХ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }